import styled from "styled-components"
import { APP_ID } from "../../helpers/constants"

const ToggleLeftButton = styled.div`
  color: #FFF;
  display: flex;
  justify-content: center;
  align-items:center;
  height: 4rem;
  background-color: ${props =>
    props.selected
      ? props.selectedBgColor || props.theme[APP_ID].black10
      : props.theme[APP_ID].black10 || props.theme.default.primary50P};
  border-top-left-radius: .2rem;
  border-bottom-left-radius: .2rem;
  width: 100%;
  text-align: center;
  font-weight: 600;
  font-size: 1.6rem;
  cursor: pointer;
  opacity: ${props => props.selected ? "1" : ".2"};
`

const ToggleRightButton = styled(ToggleLeftButton)`
  border-top-left-radius: 0rem;
  border-bottom-left-radius: 0rem;
  border-top-right-radius: .2rem;
  border-bottom-right-radius: .2rem;
`

const ToggleWrapper = styled.div`
  display: flex;
  width: 100%;
  height: 4rem;
  align-items: center;
  justify-content: center;
  border-style: none;
`

export { ToggleLeftButton, ToggleRightButton, ToggleWrapper }
